"use client";

import { KeyboardArrowRight } from "@mui/icons-material";
import { Button, IconButton, Tooltip } from "@mui/material";

export default function ViewEventButton({
  eventUuid,
  size = "medium",
  icon = true
}: {
  eventUuid: string;
  size?: "small" | "medium" | "large";
  icon?: boolean;
}) {
  return (
    <Tooltip title="View Event">
      {icon ? (
        <IconButton size={size} href={`/rangers/events/${eventUuid}`}>
          <KeyboardArrowRight />
        </IconButton>
      ) : (
        <Button
          endIcon={<KeyboardArrowRight />}
          color="primary"
          variant="contained"
          size={size}
          href={`/rangers/events/${eventUuid}`}
        >
          View
        </Button>
      )}
    </Tooltip>
  );
}
